import styled from 'styled-components';

const Container = styled.div`
  height: 115px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  border: 1px dashed ${({ theme }) => theme.colors.gray300};

  ${({ theme }) => theme.typograph.paragraphRegular}

  p {
    color: ${({ theme }) => theme.colors.gray300};
  }

  b {
    color: ${({ theme }) => theme.colors.gray300};
    font-weight: bold;
  }

  span {
    color: ${({ theme }) => theme.colors.mainColor};
  }
`;

export {
  Container,
};
